import React from 'react';
import ProactiveContent from './../../components/proactiveContent';
import { InHomeUtils } from './../../util/inhomeUtils';
import { connect } from 'react-redux'
import { Body } from '@vds/typography';
import bbqlogo from './../../assets/ak-cached/24h/img/bbq_logo.png';
import { PerksTnC } from '../midnight/DiscountFlowModal';
import { SETUPFEEWAIVEROFFER } from '../buildProduct/helperContent';

class footer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isReskin = this.props.isReskin ? this.props.isReskin : this.props.buildProductState.isReskin && this.props.lqState && this.props.lqState.runtimeKey && this.props.lqState.runtimeKey.EnableReskin === 'Y';
    }
    bbqClick = (e) => {
        if (!this.props.isTargetOrdering) {
            window.open("http://www.bbb.org/online/consumer/cks.aspx?id=108072593112", '_blank');
        }
    }

    checkIsHoa = () =>{
        return this.props.hoaFlowDetails && this.props.hoaFlowDetails.isHoaFlow;
    }

    isHighestPlan = (plans = [], targetPlan = '') => {
      const extractSpeedNum = (name) => {
        let match = name.match(/\d+/);
        return match ? parseInt(match[0], 10) : null;
      }

      const getSpeedValue = (name) => {
        name = name?.trim()?.toLowerCase();
        if(name.includes("gigabit connection") || name.includes("gig")) {
          let num = extractSpeedNum(name) || 1;
          return num * 1000;
        }
        return extractSpeedNum(name);
      }

      const speeds = (plans || [])?.map(plan => getSpeedValue(plan?.name || ''));
      const maxSpeed = Math.max(...speeds);

      return getSpeedValue(targetPlan) === maxSpeed;
    }
     getProActiveText =()=>{
      let isMax500plan=''
      const iontORvintage = this.props && this.props.buildProductState && this.props.buildProductState?.offersEligible && 
      (this.props.buildProductState?.offersEligible.indexOf("NEST_HUBMAX_DATA") > -1 || this.props.buildProductState?.offersEligible.indexOf("NEST_AUDIO_DATA") > -1 || this.props.buildProductState?.offersEligible.indexOf("Special_Ongoing_$20_Discount") > -1) ? true : false;
      const isClassicFlow = !this.props.buildProductState.internet.mm3Qualified;
        let proactiveText='';
        let oneGig = this.props.buildProductState?.isMNEnabled &&this.props.buildProductState.internet.m2mPlans?.findIndex((rr) => rr.name?.toLowerCase()?.includes("1 gig"))>-1;
        let twoGig = this.props.buildProductState?.isMNEnabled && this.props.buildProductState.internet.m2mPlans?.findIndex((rr) => rr.name?.toLowerCase()?.includes("2 gig"))>-1;
        let twoGigClassic = this.props.buildProductState?.isMNEnabled &&this.props.buildProductState?.internet?.m2mPlans?.findIndex((rr) => rr?.id === 'P5881')>-1;
        let oneGigClassic = this.props?.buildProductState?.isMNEnabled &&this.props.buildProductState?.internet?.m2mPlans?.findIndex((rr) => rr?.id === 'P5882')>-1;
        
        isMax500plan = this.isHighestPlan(this.props.buildProductState?.internet?.m2mPlans, "500 mbps");
        
        //VEC Changes
        if (
          this.props?.lqState &&
          this.props?.lqState?.lqResponse &&
          this.props?.lqState?.lqResponse?.hoaFlag &&
          this.props?.lqState?.lqResponse?.hoaFlag !== "Y"
        ) {
          if (
            this.props.lqState &&
            this.props.lqState?.runtimeKey &&
            this.props.lqState?.runtimeKey?.SetupFeeOffer &&
            this.props.lqState?.runtimeKey?.SetupFeeOffer === "Y"
          ) {
            isMax500plan =
              this.props.buildProductState?.internet?.m2mPlans?.findIndex(
                (item) => ["R3582", "R3583"].includes(item?.id)
              ) > -1
                ? false
                : isMax500plan;
            if (
              this.props?.buildProductState?.internet?.isFeeWaivedForAll
            ) {
              proactiveText =
                "Order Fios Internet and get your $99 setup charge waived.";
            }
            // According to https://onejira.verizon.com/browse/PRODDEF-40186
            // isInActiveONTPresent from the API (/retrievequaldetails) response should be equal "Y" to be qualified as iONT address
            // if it is "N" from the API, then it is not an iONT address
            else if (
              this.props?.iONTEligible &&
              this.props?.getBroadbandAvailabilityResult
                ?.fttpAvailabilityDetailsAGR?.isInActiveONTPresent === "Y"
            ) {
              proactiveText =
                "Online Exclusive: $99 setup fee waived for internet orders. All other orders may incur a $99 setup charge.";
            } else if (
              this.props?.getBroadbandAvailabilityResult
                ?.fttpAvailabilityDetailsAGR?.isInActiveONTPresent ===
                "Y" ||
              iontORvintage
            ) {
              proactiveText =
                "Online Exclusive: $99 setup fee waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
            } else if (
              this.props.buildProductState?.internet
                ?.isInstallFeeWaivedAllPrd
            ) {
              proactiveText =
                "Online Exclusive: Order Fios Internet and get your $99 setup charge waived.";
            } else if (twoGig) {
              proactiveText =
                "Online exclusive: $99 setup fee waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
            } else if (oneGig) {
              proactiveText =
                "Online exclusive: $99 setup fee waived for Fios 1 Gig. All other orders may incur a $99 setup charge.";
            } else if (isMax500plan) {
              proactiveText =
                "Online exclusive: $99 setup fee waived for Fios 500 Mbps. All other orders may incur a $99 setup charge.";
            } else if (twoGigClassic && isClassicFlow) {
              proactiveText =
                "Online exclusive: $99 setup fee waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
            } else if (oneGigClassic && isClassicFlow) {
              proactiveText =
                "Online exclusive: $99 setup fee waived for Fios 1 Gig. All other orders may incur a $99 setup charge.";
            } else {
              proactiveText =
                "Online Exclusive: Order Fios 1 Gig online and get your $99 setup charge waived.";
            }
          } else if (twoGigClassic && isClassicFlow) {
            proactiveText =
              "Online exclusive: $99 setup fee waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
          } else if (oneGigClassic && isClassicFlow) {
            proactiveText =
              "Online exclusive: $99 setup fee waived for Fios 1 Gig. All other orders may incur a $99 setup charge.";
          } else if (twoGig) {
            proactiveText =
              "Online exclusive: $99 setup fee waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
          } else if (oneGig) {
            proactiveText =
              "Online exclusive: $99 setup fee waived for Fios 1 Gig. All other orders may incur a $99 setup charge.";
          }
          //    else if (this.props.buildProductState?.isMNEnabled && !oneGig && !twoGig) {
          //     proactiveText = "Online Exclusive: $99 setup fee waived for internet orders. All other orders may incur a $99 setup charge.";
          //   }
          else if (isClassicFlow && (oneGig || twoGig)) {
            proactiveText =
              "Online Exclusive: $99 setup fee waiver waived for Fios 1 Gig and 2 Gig. All other orders may incur a $99 setup charge.";
          } else if (isClassicFlow && isMax500plan) {
            proactiveText =
              "Online exclusive: $99 setup fee waived for Fios 500 Mbps. All other orders may incur a $99 setup charge.";
          } else {
            proactiveText = "All orders may incur a $99 setup charge.";
          }
        }
        if(proactiveText && this.props.buildProductState.footerMessage===""){
          this.props.dispatch({type:"SET_FOOTER_MESSAGE",value:proactiveText.replaceAll("$","Dollar ")})
        }       
        return proactiveText;
    }

    render() {
       let tvvoiceCartFooterMobile = window && window.location && window.location.pathname && window.location.pathname.includes('streamlinetvvoice')
        let proactiveMsg = '';
        let currentYear = new Date().getFullYear();
        let pathName = window.location.pathname;
        let proactiveText = "";
        let showGNAV = false;
        let fiosReferral = window.sessionStorage.getItem('fiosReferralFlow');
        let isLBO= pathName.includes('lbo') ? true:false;
        const hideHeaderForSuspendServices = window.location && window.location.host == "www.verizon.com" && this.props.router.location?.pathname?.indexOf("suspendservices") > -1;  
        let isSetupFeeWaived = false;
        let isEligiblePlans = this.props && this.props.buildProductState && this.props.buildProductState.internet && this.props.buildProductState.internet?.m2mPlans && this.props.buildProductState.internet?.m2mPlans?.length > 0 
          && this.props.buildProductState?.internet?.m2mPlans?.filter(v => v.speedCode && (v.speedCode === "947" || v.speedCode === "941" || v.speedCode === "940")).length > 0 ? true : false;
       
        
        showGNAV = !!(pathName.indexOf('/change/') > -1 && pathName.indexOf('/accountaccess') == -1 && pathName.indexOf('/signin') == -1 && pathName.indexOf('/change/connection') == -1);
        let isSupLboMvaFlow = pathName.indexOf('/change/supp/lbo')!= -1 && window?.innerWidth < 1080;
        let isResumeCart = pathName.indexOf('/inhome/resumecart')!= -1;
        if(this.props.appState.flowType === 'AF'&&isLBO){
            showGNAV= false
        }
        if (this.props.appState.flowType === "SUPP" || hideHeaderForSuspendServices) {
            showGNAV = false;
        }

        if (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartData)&& this.props.cart.cartData.length>0 && InHomeUtils.isNotNull(this.props.cart.cartData[0].oneTimeCharge) && InHomeUtils.isNotNull(this.props.cart.cartData[0].oneTimeCharge.onetimecharge)
        && this.props.cart.cartData[0].oneTimeCharge.onetimecharge.length > 0) {
        let setup = this.props.cart.cartData[0].oneTimeCharge.onetimecharge.filter(p => p.prodType === "SETUP")
        if (InHomeUtils.isNotNull(setup) && setup.length > 0 && setup[0].price !== null) {
            if (setup[0].price === "Included") {
                isSetupFeeWaived = true;                    
            }               
        }
        }
        if (!showGNAV && !(this.checkIsHoa() && !isSetupFeeWaived) && isEligiblePlans) {
           proactiveText =this.getProActiveText();
            let deviceType = "mobile";
              const iconclass =
                InHomeUtils.getdeviceType() === deviceType
                  ? "Icon Icon--tag text-large vert-middle hide"
                  : "Icon Icon--tag text-large vert-middle";
              if (
                this.props.isbuildProductLoaded &&
                pathName.indexOf("buildproducts") > 0 &&
                proactiveText
              ) {
                // proactiveMsg = window.location.href.indexOf("buildproductsRskn") == -1 ? <ProactiveContent proactiveText={proactiveText} /> : <div className="w_ltd-offer">
                proactiveMsg =
                  window.location.href.indexOf("buildproducts") == -1 ? (
                    <ProactiveContent proactiveText={proactiveText} />
                  ) : 
                 (
                    <div className="w_ltd-offer paddingAllAround">
                      <div
                        className="ltd-offer-tile"
                        style={{
                          minHeight: "4rem",
                          background: "#F6F6F6",
                          marginTop: "24px",
                          borderRadius: "14px",
                        }}
                      >
                        <div
                          className="ltd-offer-details"
                          style={{
                            color: "#000",
                            margin: "17px auto",
                            padding: "0px 1.4rem 0px 1.25rem",
                          }}
                        >
                          <span className={iconclass} aria-hidden="true"></span>
                          <div className="inline-block medium-p-auto padding-left-micro vert-middle ">
                            <span>{proactiveText}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
              }
            }
  
        
     

        return (
            <React.Fragment>
                <footer>
                    {/* Footer for EC Flow*/}
                    <div className={`${showGNAV && fiosReferral !== "true" ? '' : 'hide'}`} id="vz-gf20"></div>
                    {/* Footer for NC and Moves Flow*/}
                    <div className={`${!showGNAV ? isLBO ?'lboFooter':'' : 'hide'}`}>
                        {proactiveMsg}
                        {/* Removing isMNEnabled check as Perks TnC should be displayed for all flows(Classic as well) whenever perks are selected */}
                        {
                            this.props.buildProductState?.perks?.selectedProduct && this.props.buildProductState?.perks?.selectedProduct?.length > 0 && !tvvoiceCartFooterMobile &&
                             <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                                <Body size='medium'>
                                    By continuing, you agree to perk <PerksTnC perks={this.props.buildProductState?.perks?.selectedProduct} buildProduct={this.props.buildProductState} lqState={this.props.lqState} cart={this.props.cart}/>
                                </Body>
                            </div>
                        }
                       {/* {window.location.href.indexOf("buildproductsRskn") == -1  && <div className="m_footer m_footer-lq"> */}
                       {(window.location.href.indexOf("buildproducts") == -1 && window.location.href.indexOf("connection?") == -1) && <div className="m_footer m_footer-lq">
                            <div className=" padding-horiz-medium">
                                {/* <div className="column tiny-6"><a onClick={(e) => this.bbqClick(e)} title="Opens New Window"><img tabIndex="0" alt="BBB ACCREDITED BUSINESS" src={bbqlogo} id="BBQ" width="97" /></a></div> */}
                                {/* <div className="column tiny-12"><p className="bold margin-bottom-tiny text-small text-right">&copy; {currentYear} Verizon</p></div> */}
                                { !isSupLboMvaFlow && !isResumeCart ?<div className="column tiny-12"><p className="bold margin-bottom-tiny text-small text-right">&copy; {currentYear} Verizon</p></div>  : null }
                            </div>
                        </div> }
                    </div>
                </footer>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        isTargetOrdering: state.app.isTargetOrdering,
        lqState: state.loopQual,
        buildProductState: state.buildProduct,
        iONTEligible: state.loopQual.iONTEligible,
        getBroadbandAvailabilityResult: state.loopQual.lqQualdetails.getBroadbandAvailabilityResult,
        hoaFlowDetails: state.loopQual.hoaFlowDetails,
        ecFooter: state.app.ecFooter,
        isbuildProductLoaded: state.buildProduct.buildprodLoaded,
        appState: state.app,
        cart:state.cart,
        router: state.router
    }
}

export default connect(
    mapStateToProps,
)(footer);
